<template>
  <div  >
    <div class="pt-5 mb-6" align="center">
<h6>gestione-segnalazioni-comuni</h6>
    </div>

 <div class="container3 d-flex mx-auto"  >
            <div class=" m-10"  >
       <h4 class="mb-5 text-center">Area accesso</h4>
        <div class="submit-form p-5 border border-primary shadow p-3 m-5 bg-white rounded" >
      <div class="form-group mb-5">
        <label for="codice">Accedi al tuo comune </label>
        <input

          type="text"
          class="form-control"
          id="codice"
          placeholder="Codice Catastale"
          required
          v-model="codice"
          name="codice"
        />
                <ul v-if="error.length"> <li v-for="e in error" :key="e"  style="color:red" >{{e}}</li>
        </ul>
  <div class="row">

     <button  @click.prevent="checkCampo()"  class="botton-secondary align-self-end m-10">Accedi</button>
     </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import ComuniDataService from '@/service/ComuniDataService.js'

export default {
  name: 'Accesso',

  data () {
    return {
      codice: null,
      error: []
    }
  },
  methods: {

    clear () {
      this.$store.dispatch('clearStore')
      this.$store.dispatch('setTheme', '')
    },
    checkComune (value) {
      if (!this.error.length) {
        console.log('set store', this.codice)
        ComuniDataService
          .getComuneById(value)
          .then(response => {
            this.$store.dispatch('logAsAdmin', response.data)
            this.$store.dispatch('setTheme', response.data.codiceCatasto)
            this.$router.push({ name: 'BackOffice', params: { cid: this.codice } })
          })
          .catch(e => {
            console.log(e)
            this.error.push('Comune non registrato')
          })
      }
    },
    validate () {
      this.error = []
      if (!this.codice) {
        this.error.push('Campo Vuoto')
      }
    },
    checkCampo () {
      this.validate()
      this.checkComune(this.codice)
    }

  },
  created () {
    this.clear()
  }
}
</script>
